export default __webpack_public_path__ + "static/undraw_medicine_b1ol-3aea205346acd1383f0744158d64369e.svg";